import {RootState} from 'common/src/redux/store';
import routingService from '../routing.service';
import {RouteWithParams} from '../routing.types';
import defaultRouteFormatter from './defaultRouteFormatter';

function formatRouteDisplayString(
  route: RouteWithParams,
  getState: () => RootState,
): string | null {
  const routeDef = routingService.getRouteDefinition(route.routeKey);

  if (!routeDef) {
    return null;
  }

  const routeFormatter = routeDef.formatter ?? defaultRouteFormatter;
  const formattedParams = routeFormatter({routeDef, route, getState});

  return formattedParams ? `${routeDef.displayName}\n${formattedParams}` : routeDef.displayName;
}

export default formatRouteDisplayString;
